import React, { useState, useEffect, useContext } from "react";
import { getDataWithToken } from "../../../services/GetDataService";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import RefreshToken from "../../../services/RefreshToken";
import { AuthContext } from "../../../context/AuthContext";
const AuthorizedGuardianInformation = () => {
  const { login, kinder_cubby_panel_user, logout } = useContext(AuthContext);
  const { slug } = useParams();
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [message, setMessage] = useState("");
  const [authorizedGuardianList, setAuthorizedGuardianList] = useState([]);
  const [authorizedGuardianDetail, setAuthorizedGuardianDetail] = useState({});

  const getData = async () => {
    setLoading(true);
    setMessage("");
    let token = await RefreshToken(kinder_cubby_panel_user, logout, login);
    const parentIdUrl = `${process.env.REACT_APP_AUTH_URL}/api/v1/private/kid/${slug}/pickup-authorization`;
    let response = await getDataWithToken(parentIdUrl, token);

    if (response.status >= 200 && response.status < 300) {
      if (response?.data.length > 0) {
        setAuthorizedGuardianList(response?.data);
        setAuthorizedGuardianDetail(response?.data[0]);
        setActiveIndex(0);
      } else {
        setMessage("No data found");
      }
    } else {
      setMessage(response.data.messages.toString());
      if (response.data.messages.length < 1) {
        setMessage("Something went wrong");
      }
    }
    setLoading(false);
  };

  const getNextAndPrevious = (type) => {
    if (type === "next") {
      if (authorizedGuardianList?.length - 1 > activeIndex) {
        setActiveIndex(parseInt(activeIndex + 1));
        setAuthorizedGuardianDetail(
          authorizedGuardianList[parseInt(activeIndex + 1)]
        );
      }
    } else {
      if (activeIndex > 0) {
        setAuthorizedGuardianDetail(
          authorizedGuardianList[parseInt(activeIndex - 1)]
        );
        setActiveIndex(parseInt(activeIndex - 1));
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs="auto">
          <Typography
            variant="h6"
            component="div"
            style={{ position: "relative", fontSize: "18px" }}
          >
            Pick-up Authorization
          </Typography>
        </Grid>
        <Grid item xs="auto" style={{ textAlign: "right" }}>
          <IconButton
            size="small"
            disabled={activeIndex === 0}
            style={{
              color: "#999999",
              border: "1px solid #999999",
              marginRight: "5px",
              opacity: activeIndex === 0 ? 0.5 : 1,
            }}
            onClick={() => getNextAndPrevious("")}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>

          <IconButton
            size="small"
            disabled={authorizedGuardianList.length - 1 <= activeIndex}
            style={{
              color: "#999999",
              border: "1px solid #999999",
              // marginRight: "5px",
              opacity:
                authorizedGuardianList.length - 1 <= activeIndex ? 0.5 : 1,
            }}
            onClick={() => getNextAndPrevious("next")}
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        </Grid>
      </Grid>

      <hr />
      <br />
      {message.length > 0 ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "250px", background: "#f5f5f5" }}
        >
          <Typography variant="h5" component="div" style={{ color: "#999999" }}>
            {message}
          </Typography>
        </Grid>
      ) : (
        <>
          <div style={{ textAlign: "center", marginBottom: "15px" }}>
            {loading ? (
              <>
                <div style={{ margin: "auto", width: "70px" }}>
                  <Skeleton variant="circular" width={70} height={70} />
                </div>
                <div style={{ margin: "auto", width: "210px" }}>
                  <Skeleton variant="rectangular" width={210} />
                </div>
                <div style={{ margin: "auto", width: "250px" }}>
                  <Skeleton variant="rectangular" width={250} height={10} />
                </div>
              </>
            ) : (
              <>
                <img
                  src={
                    authorizedGuardianDetail?.photo?.length > 0
                      ? authorizedGuardianDetail?.photo
                      : "/image/NoImage.jpg"
                  }
                  alt=""
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                  }}
                />
                <Typography variant="h6">
                  {" "}
                  {authorizedGuardianDetail?.name}
                </Typography>
                <div
                  style={{
                    color: "#999999",
                    fontSize: "18px",
                    marginTop: "-6px",
                  }}
                >
                  <PhoneIphoneIcon
                    sx={{
                      position: "relative",
                      top: 3,
                      fontSize: "18px",
                    }}
                  />{" "}
                  {authorizedGuardianDetail.phoneNumber}
                </div>
              </>
            )}
          </div>
          <Grid container>
            <Grid item xs={12}>
              {loading ? (
                <Skeleton variant="rectangular" height={110} />
              ) : (
                <Grid container style={{ padding: "0px 20px" }}>
                  <Grid
                    item
                    xs={6}
                    style={{
                      paddingBottom: "5px",
                    }}
                  >
                    {" "}
                    <Typography
                      variant="caption"
                      style={{
                        color: "#808080",
                      }}
                    >
                      Relation
                    </Typography>
                    <Typography variant="body2">
                      {authorizedGuardianDetail?.relation}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      textAlign: "right",
                      paddingBottom: "5px",
                    }}
                  >
                    {" "}
                    <Typography
                      variant="caption"
                      style={{
                        color: "#808080",
                      }}
                    >
                      Status
                    </Typography>
                    <Typography variant="body2">
                      {authorizedGuardianDetail.status ? (
                        <span style={{ color: "#10ac84" }}>Active</span>
                      ) : (
                        <span style={{ color: "#ee5253" }}>Inactive</span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      // color: "#808080",
                      // borderBottom: "1px solid #ddd",
                      paddingBottom: "5px",
                    }}
                  >
                    {" "}
                    <Typography
                      variant="caption"
                      style={{
                        color: "#808080",
                      }}
                    >
                      Start Date
                    </Typography>
                    <Typography
                      variant="body2"

                      // style={{ marginBottom: "30px" }}
                    >
                      {authorizedGuardianDetail?.startDate}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      // color: "#808080",
                      // borderBottom: "1px solid #ddd",
                      textAlign: "right",
                      paddingBottom: "5px",
                    }}
                  >
                    {" "}
                    <Typography
                      variant="caption"
                      style={{
                        color: "#808080",
                      }}
                    >
                      End Date
                    </Typography>
                    <Typography
                      variant="body2"
                      //  style={{ fontWeight: 500 }}
                    >
                      {authorizedGuardianDetail?.endDate}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default AuthorizedGuardianInformation;
